// DesktopSidebar.js
import { Link, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';

// Убираем MenuButton - кнопка будет только в TopBar

const SidebarContainer = styled.aside`
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  width: ${props => props.isCollapsed ? '80px' : '300px'};
  background-color: var(--primary-color);
  transition: width 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);

  /* Улучшенный скроллбар */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

const Profile = styled.div`
  padding: ${props => props.isCollapsed ? '15px 10px' : '20px'};
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  img {
    display: block;
    width: ${props => props.isCollapsed ? '36px' : '60px'};
    height: ${props => props.isCollapsed ? '36px' : '60px'};
    border-radius: 50%;
    margin: 0 auto ${props => props.isCollapsed ? '0' : '10px'};
    transition: all 0.3s ease;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }

  h6 {
    color: white;
    margin: 0;
    font-size: ${props => props.isCollapsed ? '0' : '14px'};
    opacity: ${props => props.isCollapsed ? '0' : '1'};
    visibility: ${props => props.isCollapsed ? 'hidden' : 'visible'};
    transition: all 0.3s ease;
    white-space: nowrap;
    overflow: hidden;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    height: ${props => props.isCollapsed ? '0' : 'auto'};
  }
`;

const NavLinks = styled.nav`
  padding: 10px 0;
  flex: 1;
  overflow-y: auto;
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: ${props => props.isCollapsed ? '15px 0' : '15px 20px'};
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
  position: relative;
  justify-content: ${props => props.isCollapsed ? 'center' : 'flex-start'};

  img {
    width: ${props => props.isCollapsed ? '24px' : '20px'};
    height: ${props => props.isCollapsed ? '24px' : '20px'};
    margin-right: ${props => props.isCollapsed ? '0' : '15px'};
    filter: brightness(1);
    transition: all 0.3s ease;
  }

  span {
    opacity: ${props => props.isCollapsed ? '0' : '1'};
    visibility: ${props => props.isCollapsed ? 'hidden' : 'visible'};
    transition: all 0.3s ease;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    width: ${props => props.isCollapsed ? '0' : 'auto'};
    overflow: hidden;
  }

  &:hover {
    background-color: #2d5016;
    color: white;
    transform: ${props => props.isCollapsed ? 'scale(1.05)' : 'translateX(5px)'};
  }

  &.active {
    background-color: #2d5016;
    color: white;
    border-left-color: ${props => props.isCollapsed ? 'transparent' : '#feca57'};
  }
`;

function Sidebar({ isCollapsed }) {
  const location = useLocation();

  const menuItems = [
    { path: '/admin', img: '/assets/admin/icon/микро.svg', text: 'АНОНСЫ СОБЫТИЙ' },
    { path: '/admin/news', img: '/assets/admin/icon/книга.svg', text: 'НОВОСТИ БИБЛИОТЕКИ' },
    { path: '/admin/new-arrivals', img: '/assets/admin/icon/корзина.svg', text: 'НОВЫЕ ПОСТУПЛЕНИЯ' },
    { path: '/admin/ask-librarian', img: '/assets/admin/icon/вопросы.svg', text: 'ВОПРОС БИБЛИОТЕКАРЮ' },
    { path: '/admin/menu-editor', img: '/assets/admin/icon/pages.svg', text: 'МЕНЮ' },
    { path: '/admin/admin-management', img: '/assets/admin/icon/admins.svg', text: 'АДМИНИСТРАТОРЫ' },
    { path: '/admin/user-management', img: '/assets/admin/icon/users.svg', text: 'ПОЛЬЗОВАТЕЛИ' },
    { path: '/admin/page-editor', img: '/assets/admin/icon/page.svg', text: 'СТРАНИЦА' },
    { path: '/admin/resupply', img: '/assets/admin/icon/докоплектование.svg', text: 'ДОКОМПЛЕКТОВАНИЕ' },
  ];

  const name = localStorage.getItem('name');

  return (
    <SidebarContainer isCollapsed={isCollapsed}>
      <Profile isCollapsed={isCollapsed}>
        <img src="/assets/admin/logo/logo.png" alt="Аватар" />
        <h6>{name}</h6>
      </Profile>

      <NavLinks>
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            isCollapsed={isCollapsed}
            className={location.pathname === item.path ? 'active' : ''}
          >
            <img src={item.img} alt="icon" />
            <span>{item.text}</span>
          </NavLink>
        ))}
      </NavLinks>
    </SidebarContainer>
  );
}

export default Sidebar;